<template>
  <card class="riseup-goal container-padding">
    <div class="container-padding" :class="{ 'showing-edit-menu': showSectionMenu, 'out-of-date': outOfDate }">
      <div class="top-line">
        <div class="header">
          <img v-if="outOfDate" :src="require('@/assets/goal-circle-disabled.svg')">
          <img v-else :src="require('@/assets/goal-circle.svg')">
          <div class="goal" :class="{ 'out-of-date': outOfDate }">יעד riseup</div>
        </div>
        <img v-if="!outOfDate && !blocked" class="edit" v-on:click.stop="openSectionMenu"
             :src="require('@/assets/icons/menu.svg')">
      </div>
      <div class="text" :class="{ 'out-of-date': outOfDate }">
        <div>אני רוצה לשים בצד החודש</div>
        <div class="goal-amount" :class="{ 'out-of-date': outOfDate }">{{ formattedRiseupGoal }}</div>
      </div>
    </div>
    <riseup-goal-section-menu v-if="showSectionMenu"
                            :closeMenu="() => this.showSectionMenu = false"/>
  </card>
</template>

<script>

import { mapGetters } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../../../../../Segment';
import moneyUtils from '../../../../../../../../../utils/money';
import RiseupGoalSectionMenu from '../../../current-month/components/cashflow-edit/edit-riseup-goal/RiseupGoalSectionMenu.vue';

export default {
  name: 'CashflowTypeBaseRiseupGoal',
  components: {
    Card: BaseUI.Card,
    RiseupGoalSectionMenu,
  },
  data() {
    return {
      showSectionMenu: false,
    };
  },
  props: {
    outOfDate: {
      type: Boolean,
      default: false,
    },
    blocked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('cashflowView', ['monthName', 'riseupGoal', 'remainingVariables']),
    formattedRiseupGoal() {
      return this.blocked ? '***' : `${moneyUtils.formatAmountWithFraction(this.riseupGoal, 0)} ₪`;
    },
    hasRemainingVariables() {
      return this.remainingVariables > 0;
    },
  },
  methods: {
    openSectionMenu() {
      Segment.trackUserInteraction('OpenSectionMenuClicked', {
        expenseCategory: 'riseup-goal',
      });
      this.showSectionMenu = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .riseup-goal {
    @include cashflow-card-padding-top;
    color: $riseup_black;
    padding-top: 24px;
    padding-bottom: 20px;
    position: relative;
    font-family: SimplerPro;

    .container-padding {
      &.out-of-date {
        color: $riseup_gray_2;
      }
      &.showing-edit-menu {
        opacity: 0.5;
      }
    }

    .top-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .header {
        display: flex;
        align-items: center;

        .goal {
          @include cashflow-h2;
          margin-right: 10px;
          &.out-of-date {
            color: $riseup_gray_2;
          }
        }
      }

      .edit {
        height: 36px;
        cursor: pointer;
        position: absolute;
        top: 14px;
        left: 4px;
        padding: 10px 20px;
      }
    }

    .text {
      @include cashflow-h1;
      &.out-of-date {
        color: $riseup_gray_2;
      }

      .goal-amount {
        display: inline-block;
        margin-top: 5px;
        color: $riseup_yellow;
        font-size: 24px;
        &.out-of-date {
          color: $riseup_gray_2;
        }
      }
    }
  }
</style>
